import { useStore } from '@stores';
import { InventoryService } from '@services';
import { debounce } from 'lodash';
import { useCallback, useEffect, useMemo, useState } from 'react';

export const useSuppliers = () => {
  const { supplierStore } = useStore();
  const {
    suppliers,
    totalCount,
    loading,
    currentPage,
    skipCount,
    maxResultCount,
    setSkipCount,
    setCurrentPage,
  } = supplierStore;

  const [name, setName] = useState<string>('');
  const [contactName, setContactName] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [phone, setPhone] = useState<string>('');

  useEffect(() => {
    supplierStore.getAll({
      name,
      contactName,
      email,
      phone,
      maxResultCount,
      skipCount,
    });
  }, [name, contactName, email, phone, maxResultCount, skipCount]); // eslint-disable-line react-hooks/exhaustive-deps

  const handlePageChange = (pagination: any) => {
    supplierStore.handlePageChange(pagination);
  };

  const handleNameSearch = useMemo(() => debounce((text: string) => {
    setName(text);
    setSkipCount(0);
    setCurrentPage(1);
  }, 500), [setSkipCount, setCurrentPage]);

  const handleContactSearch = useMemo(() => debounce((text: string) => {
    setContactName(text);
    setSkipCount(0);
    setCurrentPage(1);
  }, 500), [setSkipCount, setCurrentPage]);

  const handleEmailSearch = useMemo(() => debounce((text: string) => {
    setEmail(text);
    setSkipCount(0);
    setCurrentPage(1);
  }, 500), [setSkipCount, setCurrentPage]);

  const handlePhoneSearch = useMemo(() => debounce((text: string) => {
    setPhone(text);
    setSkipCount(0);
    setCurrentPage(1);
  }, 500), [setSkipCount, setCurrentPage]);

  const refresh = useCallback(() => {
    supplierStore.getAll({
      name,
      contactName,
      email,
      phone,
      maxResultCount,
      skipCount,
    });
  }, [name, contactName, email, phone, maxResultCount, skipCount]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchAllForExport = useCallback(async () => {
    const result = await InventoryService.getAllSuppliers({
      name,
      contactName,
      email,
      phone,
      maxResultCount: totalCount || 10000,
      skipCount: 0,
    });
    return result.items;
  }, [name, contactName, email, phone, totalCount]);

  return {
    loading,
    dataSource: Array.from(suppliers.values()),
    totalCount,
    currentPage,
    maxResultCount,
    handlePageChange,
    handleNameSearch,
    handleContactSearch,
    handleEmailSearch,
    handlePhoneSearch,
    refresh,
    fetchAllForExport,
  };
};
